import {
  ParagraphArticleHighlights,
  ParagraphArticleOverview,
  ParagraphAccordion,
  ParagraphAccordionItem,
  ParagraphCTA,
  ParagraphDownloads,
  ParagraphFAQ,
  ParagraphFaqThemes,
  ParagraphLinkList,
  ParagraphMap,
  ParagraphPartnersHighlights,
  ParagraphPartnersOverview,
  ParagraphQuote,
  ParagraphTargetAudiencesHighlighted,
  ParagraphTeam,
  ParagraphText,
  ParagraphTextImageGrid,
  ParagraphTextMedia,
  ParagraphThemesHighlighted,
  ParagraphTopical,
  ParagraphUSP,
  ParagraphUSPSubparagraph,
  ParagraphWebform,
} from '../implementations';

const mappers = {
  article_highlights: ParagraphArticleHighlights,
  article_overview: ParagraphArticleOverview,
  accordion: ParagraphAccordion,
  accordion_item: ParagraphAccordionItem,
  cta_wrapper: ParagraphCTA,
  downloads: ParagraphDownloads,
  faq: ParagraphFAQ,
  faq_themes: ParagraphFaqThemes,
  link_list: ParagraphLinkList,
  map: ParagraphMap,
  partners_highlighted: ParagraphPartnersHighlights,
  partners_overview: ParagraphPartnersOverview,
  quote: ParagraphQuote,
  target_audiences_highlighted: ParagraphTargetAudiencesHighlighted,
  team: ParagraphTeam,
  text_image_grid: ParagraphTextImageGrid,
  text_media: ParagraphTextMedia,
  text: ParagraphText,
  themes_highlighted: ParagraphThemesHighlighted,
  topical: ParagraphTopical,
  usp_subparagraph: ParagraphUSPSubparagraph,
  usp: ParagraphUSP,
  webform_wrapper: ParagraphWebform,
};

export default mappers;
